import React, { useEffect, useState } from 'react';

import { Title } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';

import DrawerStaffForm from './components/DrawerStaffForm/DrawerStaffForm';
import StaffPageHeader from './components/StaffPageHeader';
import StaffTableContainer from './components/StaffTableContainer';

interface FilterTerms {
  searchTerm: string;
  isArrangeByLastName: boolean;
  loginEnabled: string;
}

const StaffPage = (): JSX.Element => {
  const initialSearchFiltersValue = {
    searchTerm: '',
    isArrangeByLastName: false,
    loginEnabled: 'true',
  };
  const [isCreateFormOpened, { open, close }] = useDisclosure(false);
  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);
  const [staffId, setStaffId] = useState<string>('');
  const [type, setType] = useState<'create' | 'edit'>('create');
  const [orderingValue, setOrderingValue] = useState<string>('firstName');
  const { hasPerm } = useAuth();
  const staffPerm = hasPerm('StaffMutate');

  const createOrEdit = (): JSX.Element => {
    if (type === 'create') {
      return <Title order={3}>Create Staff</Title>;
    }
    return <Title order={3}>Edit Staff</Title>;
  };

  const handleCloseAndResetForm = (): void => {
    close();
    setStaffId('');
    setType('create');
  };

  useEffect(() => {
    if (staffId) {
      setType('edit');
      open();
    }
  }, [staffId, open]);

  return (
    <>
      <StaffPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        handleOpenCreateForm={open}
        permission={staffPerm}
      />

      <StaffTableContainer
        data-cy='staffTableContainer'
        searchFilters={debouncedSearchFilters}
        handleOpenStaffForm={open}
        setStaffId={setStaffId}
        setOrderingValue={setOrderingValue}
        permission={staffPerm}
      />

      <DrawerStaffForm
        formId='create-staff-form'
        opened={isCreateFormOpened}
        title={createOrEdit()}
        closeHandler={handleCloseAndResetForm}
        type={type}
        staffId={staffId}
        permission={staffPerm}
      />
    </>
  );
};

export default StaffPage;
